module.exports = __webpack_public_path__ + "img/top_logo.760075c.png";